var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("editor-menu-bar", {
        attrs: { editor: _vm.editor },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var commands = ref.commands
              var isActive = ref.isActive
              return _c(
                "div",
                { staticClass: "mb-2 mt-2 flex justify-content-between" },
                [
                  _c("span", [
                    _c(
                      "span",
                      {
                        staticClass: "pointer",
                        class: { "is-active": isActive.bold() },
                        on: { click: commands.bold }
                      },
                      [_c("i", { staticClass: "fa fa-bold p-2 menubar-icon" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "pointer",
                        class: { "is-active": isActive.italic() },
                        on: { click: commands.italic }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-italic p-2 menubar-icon"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "pointer",
                        class: { "is-active": isActive.underline() },
                        on: { click: commands.underline }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-underline p-2 menubar-icon"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "p-2" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer dropdown-toggle variables",
                          attrs: {
                            id: "alignButton",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          }
                        },
                        [_c("i", { staticClass: "fa fa-align-left p-2" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          attrs: {
                            id: "dropdownAlign",
                            "aria-labelledby": "alignButton"
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  commands.paragraph({ textAlign: "left" })
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-align-left p-2" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  commands.paragraph({ textAlign: "center" })
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-align-center p-2" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  commands.paragraph({ textAlign: "right" })
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-align-right p-2" })]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            commands.createTable({
                              rowsCount: 3,
                              colsCount: 3,
                              withHeaderRow: false
                            })
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-table p-2 menubar-icon" })]
                    ),
                    _vm._v(" "),
                    isActive.table()
                      ? _c("span", { staticClass: "p-2" }, [
                          _c(
                            "span",
                            {
                              staticClass: "pointer dropdown-toggle",
                              attrs: { "data-toggle": "dropdown" }
                            },
                            [_c("i", { staticClass: "fa fa-pencil-square-o" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu tabledrp",
                              attrs: { "aria-labelledby": "headingButtonn" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: { click: commands.addColumnBefore }
                                },
                                [_vm._v("Add column left")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: { click: commands.addColumnAfter }
                                },
                                [_vm._v("Add column right")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: { click: commands.addRowAfter }
                                },
                                [_vm._v("Add row below")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: { click: commands.addRowBefore }
                                },
                                [_vm._v("Add row above")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: { click: commands.toggleCellMerge }
                                },
                                [_vm._v("Merge cells")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: { click: commands.deleteRow }
                                },
                                [_vm._v("Delete row")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: { click: commands.deleteColumn }
                                },
                                [_vm._v("Delete column")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: { click: commands.deleteTable }
                                },
                                [_vm._v("Delete table")]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.showImagePrompt(commands.image)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-image p-2 menubar-icon" })]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "pr-2" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer dropdown-toggle variables",
                          attrs: {
                            id: "headingButton",
                            "data-toggle": "dropdown"
                          }
                        },
                        [_c("i", { staticClass: "fa fa-header p-2" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          attrs: { "aria-labelledby": "headingButtonn" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  commands.heading({ level: 1 })
                                }
                              }
                            },
                            [_vm._v("Heading")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  commands.heading({ level: 3 })
                                }
                              }
                            },
                            [_vm._v("Subheading")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return commands.paragraph($event)
                                }
                              }
                            },
                            [_vm._v("Paragraph")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pr-2" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer dropdown-toggle variables",
                          attrs: {
                            id: "warningButtons",
                            "data-toggle": "dropdown"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-exclamation-triangle p-2"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          attrs: { "aria-labelledby": "warningButtons" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  commands.warningInput({
                                    class: "alert-primary",
                                    inputClass: "info-input"
                                  })
                                }
                              }
                            },
                            [_vm._v("\n              Info\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  commands.warningInput({
                                    class: "alert-warning",
                                    inputClass: "disclaimer-input"
                                  })
                                }
                              }
                            },
                            [_vm._v("\n              Disclaimer\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  commands.warningInput({
                                    class: "alert-danger",
                                    inputClass: "warning-input"
                                  })
                                }
                              }
                            },
                            [_vm._v("\n              Warning\n            ")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pr-2" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer dropdown-toggle variables",
                          attrs: {
                            id: "inputButton",
                            "data-toggle": "dropdown"
                          }
                        },
                        [_vm._v("\n            Input\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          attrs: { "aria-labelledby": "inputButtonn" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return commands.todo_list($event)
                                }
                              }
                            },
                            [_vm._v("Checkbox")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  commands.inputs()
                                }
                              }
                            },
                            [_vm._v("Single field")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "p-2" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer dropdown-toggle variables",
                          attrs: {
                            id: "variableButton",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          }
                        },
                        [_vm._v("\n            Variables\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          attrs: {
                            id: "dropdownVariable",
                            "aria-labelledby": "variableButton"
                          }
                        },
                        [
                          _c("VueFuse", {
                            staticClass: "dropdown-item",
                            attrs: {
                              placeholder: "Search for variable",
                              keys: ["name"],
                              list: _vm.variablesArray
                            },
                            on: { fuseResultsUpdated: _vm.search }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.vars, function(variable, index) {
                            return _c(
                              "a",
                              {
                                key: variable.name,
                                staticClass: "dropdown-item variables-font",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    commands.mention({
                                      id: index,
                                      label: variable.name
                                    })
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(variable.name) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "pointer", on: { click: commands.undo } },
                      [_c("i", { staticClass: "fa fa-undo p-2 menubar-icon" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "pointer", on: { click: commands.redo } },
                      [
                        _c("i", {
                          staticClass: "fa fa-repeat p-2 menubar-icon"
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "flex" }, [
                    _c(
                      "span",
                      {
                        staticClass: "pointer pr-2",
                        staticStyle: { order: "1" },
                        attrs: { "data-toggle": "dropdown" }
                      },
                      [_c("i", { staticClass: "fa fa-eye p-2" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu p-3",
                        attrs: { "aria-labelledby": "showComponentButton" }
                      },
                      [
                        _c("form", [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("Show component to")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "switchToggle flex justify-content-between pb-2 pt-4"
                            },
                            [
                              _c("span", [_vm._v("Customer")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.component.customer_display,
                                    expression: "component.customer_display"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "customer" + _vm.componentId,
                                  value: "true"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.component.customer_display
                                  )
                                    ? _vm._i(
                                        _vm.component.customer_display,
                                        "true"
                                      ) > -1
                                    : _vm.component.customer_display
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.component.customer_display,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "true",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.component,
                                            "customer_display",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.component,
                                            "customer_display",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.component,
                                        "customer_display",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: { for: "customer" + _vm.componentId }
                                },
                                [_vm._v("Toggle")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "switchToggle flex justify-content-between"
                            },
                            [
                              _c("span", [_vm._v("Foreman")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.component.mover_display,
                                    expression: "component.mover_display"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "foreman" + _vm.componentId,
                                  value: "true"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.component.mover_display
                                  )
                                    ? _vm._i(
                                        _vm.component.mover_display,
                                        "true"
                                      ) > -1
                                    : _vm.component.mover_display
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.component.mover_display,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "true",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.component,
                                            "mover_display",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.component,
                                            "mover_display",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.component,
                                        "mover_display",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "foreman" + _vm.componentId } },
                                [_vm._v("Toggle")]
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-trash p-2 pointer",
                      staticStyle: { order: "2" },
                      on: {
                        click: function($event) {
                          _vm.$emit("deleted")
                        }
                      }
                    })
                  ])
                ]
              )
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("editor-content", {
        staticClass: "editor-styling",
        attrs: { editor: _vm.editor }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4531ee58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4531ee58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/TextEditor.vue
// module id = null
// module chunks = 